/* eslint-disable import/prefer-default-export */

import { BILLING_ADDRESS, OTHER_DETAILS } from './new-ExpressLetter';

export const MOBILESTATION = 'mobileStationInformation';
export const MOBILEINFORMATION = 'mobileInformation';
export const LICENCE_DETAILS = 'licence-details';
export const CORRESPONDENCE_DETAILS = 'corrsepondence-details';
export const BILLING_DETAILS = 'billing-details';

export const NEW_MYAPPLICATION_LOCALISEDNETWORK = [
    {
        sectionID: CORRESPONDENCE_DETAILS,
        sectionName: 'Contact Person Particulars Details',
        fieldList: [
            {
                id: 'sameAsContactPersonParticulars',
                label: 'Same As Contact Person Particulars',
                type: 'text',
                span: 12
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'mobileNo',
                label: 'Mobile No',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'telNumber',
                label: 'Office No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'text',
                rule: { required: true, charLength: 32 },
                isNextEmpty: true
            }
        ]
    },
    {
        sectionID: BILLING_DETAILS,
        sectionName: 'Billing Person Particulars',
        fieldList: [
            {
                id: 'sameAsContactPersonParticulars',
                label: 'Same As Contact Person Particulars',
                type: 'text',
                span: 12
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'mobileNo',
                label: 'Mobile No',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'telNumber',
                label: 'Office No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'text',
                rule: { required: true, charLength: 32 },
                isNextEmpty: true
            }
        ]
    },
    {
        sectionID: BILLING_ADDRESS,
        sectionName: 'Billing Address',
        fieldList: [
            {
                id: 'mailingAddress',
                label: 'Same As Mailing Address',
                type: 'text',
                isNextEmpty: true
            },
            {
                id: 'Postal',
                label: 'Postal Code',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: { required: true, charLength: 32 }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: { charLength: 66 }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: { charLength: 3 }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: { charLength: 5 },
                isNextEmpty: true
            },
            {
                id: 'renewal',
                label: 'Do you want your renewal be paid through GIRO?',
                type: 'text'
            },
            {
                id: 'imdaArrangement',
                label: 'Do you have an existing GIRO arrangement with IMDA?',
                type: 'text'
            },
            {
                id: 'bank',
                label: 'Bank',
                type: 'text'
            },
            {
                id: 'bankNumber',
                label: 'Bank account number',
                type: 'text'
            },
            {
                id: 'eInvoice',
                label: 'Do you require e-invoice on Vendors@gov',
                type: 'text'
            },
            {
                id: 'businessUnitNumber',
                label: 'Sub-business Unit Number',
                type: 'text'
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'use-of-system',
                label: 'Proposed Use of System',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Network Information',
        fieldList: []
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Operating Address',
        fieldList: [
            {
                id: 'postal-no',
                label: 'Postal code',
                type: 'text'
            },
            {
                id: 'block-no',
                label: 'Block / House No',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text',
                span: 6
            },
            {
                id: 'floor',
                label: 'Floor / Level',
                type: 'text',
                span: 2
            },
            {
                id: 'unit',
                label: 'Unit',
                type: 'text',
                span: 2
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: ' ',
        fieldList: [
            {
                id: 'lat-deg',
                label: 'Latitude Degrees',
                type: 'text',
                span: 4
            },
            {
                id: 'lat-min',
                label: 'Latitude Minutes',
                type: 'text',
                span: 4
            },
            {
                id: 'lat-sec',
                label: 'Latitude Seconds',
                type: 'text',
                span: 4
            },
            {
                id: 'lon-deg',
                label: 'Longitude Degrees',
                type: 'text',
                span: 4
            },
            {
                id: 'lon-minutes',
                label: 'Longitude Minutes',
                type: 'text',
                span: 4
            },
            {
                id: 'lon-sec',
                label: 'Longitude Seconds',
                type: 'text',
                span: 4
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Portable Information',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text',
                span: 4
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text',
                span: 4
            },
            {
                id: 'num-of-portables',
                label: 'Number of Portables',
                type: 'text',
                span: 4
            }
        ]
    }
];
